import React from 'react';
import { css } from '@emotion/core';
import { CapabilityDTO } from '@atlassiansox/phobos-client-ts';

import { SPACE_COMPACT } from '@/styles';

import PastIncidents from './past-incidents';
import BreachingSLOs from './breaching-slos';
import Dependencies from './dependencies';

const capabilityStatsInfoStyles = css`
  display: grid;
  grid-gap: ${SPACE_COMPACT}px;
  justify-items: flex-end;
`;

type CapabilityStatsInfoProps = Pick<
  CapabilityDTO,
  'publicId' | 'breaches' | 'downstreamDependencies' | 'upstreamDependencies'
>;

const CapabilityStatsInfo: React.FC<CapabilityStatsInfoProps> = ({
  publicId,
  breaches,
  downstreamDependencies = [],
  upstreamDependencies = [],
}) => (
  <div css={capabilityStatsInfoStyles}>
    <PastIncidents publicId={publicId} />
    <BreachingSLOs title="Open SLO breaches" breaches={breaches} capabilityId={publicId} />
    <Dependencies
      downstreamDependencies={downstreamDependencies}
      upstreamDependencies={upstreamDependencies}
    />
  </div>
);

export default CapabilityStatsInfo;
